import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addBranchRes;
export const addBranchTodo = createAsyncThunk('addBranch', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'add_branch',
            data: {
                "name": data.name,
                "status": data.status
            },
            headers: { "Content-Type": "application/json" }
        })
        return addBranchRes = res.data

    } catch (error) {
        return addBranchRes = error.response.data
    }
})
export var updateBranchRes;
export const updateBranchTodo = createAsyncThunk('updateBranch', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'update_branch',
            data: {
                "id": data.id,
                "name": data && data.values && data.values.name,
                'status':data && data.values && data.values.status,
            },
            headers: { "Content-Type": "application/json" }
        })
        return updateBranchRes = res.data

    } catch (error) {
        return updateBranchRes = error.response.data
    }
})
